import { Component, OnInit } from '@angular/core';
import { StrategyService } from '../services/strategy.service';
import { MainComponent } from './main/main.component';
import { ValuesComponent } from './values/values.component';
import { InterlocutorsComponent } from './interlocutors/interlocutors.component';
import { FooterComponent } from '../shared/components/footer/footer.component';
import { PillarsComponent } from './foundations/pillars.component';
import { Strategy } from '../interfaces/models/strategy.model';
import { TranslateModule } from '@ngx-translate/core';
import { Strategy404Component } from '../shared/components/strategy404/strategy404.component';
import { AuthService } from '../services/auth.service';
import { authUser } from '../interfaces/auth/auth.model';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [MainComponent, Strategy404Component, TranslateModule, ValuesComponent, InterlocutorsComponent, FooterComponent, PillarsComponent],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent implements OnInit {
  defualtStrategy !: Strategy | undefined;

  constructor(private strategy: StrategyService) {
  }
  ngOnInit(): void {
    this.strategy.defaultStrategy$.subscribe((strategy) => {
      this.defualtStrategy = strategy;
    })

  }

}
